<template>
  <div id="live-service" >
    <van-tabs v-model="active" @change="headTabs" sticky>
      <van-tab title="上海地区">
        <div class="shanghai" >
          <h3>服务优势</h3>
          <div >
            <div class="list" >
              <span></span>
              <p>斑马邦自有团队，拍摄经验丰富</p>
            </div>
            <div class="list" >
              <span></span>
              <p>精细化过程管控，服务质量稳定</p>
            </div>
          </div>
          <h3>服务价格</h3>
          <div class="table-wrapper" >
            <div class="header" >
              <div>场次类型</div>
              <div>单场价格</div>
              <div>20+场优惠</div>
              <div>比赛限时</div>
            </div>
            <div class="main" >
              <div class="wrapper" v-for="(item, index) in serviceList" :key="index" >
                <div>{{ item.type }}</div>
                <div>{{ item.money }}</div>
                <div>{{ item.discount }}</div>
                <div>{{ item.time }}</div>
              </div>
            </div>
          </div>
          <div class="edit" >
            <p>1.价格已包含基础直播场次开通费用。</p>
            <p>2.此收费标准适用于上海地区（金山、崇明两区派人直播服务在上述标准价格 之外额外酌情收取交通补贴费用）。</p>
            <p>3.所购服务包含赛事通APP直播跟拍及得分/精彩镜头打点，不包含比赛解说服务及赛事数据录入服务。</p>
            <!--              <p>4.此价格标准仅适用于单场比赛时长2小时以内的比赛。</p>-->
            <p>4.此价格标准自2020年5月1日起执行。</p>
          </div>
          <div style="height: 55px; width: 100%" ></div>
          <div class="submit" @click="routerReservation(1)" >预约服务</div>
        </div>
      </van-tab>
      <van-tab title="其他城市">
        <div class="other" >
          <h3>服务优势</h3>
          <div class="info" >
            凭借与各地赛事服务机构的长期广泛合作，斑马邦可协助您对接
            当地优质赛事服务资源：
          </div>
          <div >
            <div class="list" >
              <span></span>
              <p>比赛直播拍摄</p>
            </div>
            <div class="list" >
              <span></span>
              <p>比赛解说</p>
            </div>
            <div class="list" >
              <span></span>
              <p>赛事策划执行</p>
            </div>
            <div class="list" >
              <span></span>
              <p>赛事上线及数据维护</p>
            </div>
            <div class="list" >
              <span></span>
              <p>裁判</p>
            </div>
          </div>
          <div class="info" >斑马邦服务网络优势</div>
          <div >
            <div class="list" >
              <span></span>
              <p>对接优质赛事服务资源</p>
            </div>
            <div class="list" >
              <span></span>
              <p>协助客户维护正当权益</p>
            </div>
            <div class="list" >
              <span></span>
              <p>引导合作机构合理定价</p>
            </div>
          </div>
          <div class="submit-other" >
            <div @click="routerReservation(2)" >预约服务</div>
            <div @click="routerReservation(3)" >洽谈合作</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!--
    <div class="online-advisory" onclick="qimoChatClick();" >
      <img src="@/assets/images/human-services.png" >
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue'
import { setTitle } from '@/libs/ds-bridge'
import { Tab, Tabs } from 'vant'
import { AppType } from '@/utils/index'
import { ImageFormat } from '@/utils'
Vue.use(Tab).use(Tabs)
const service = [
  {type: '5人制赛事', money: '230元/场', discount: '95折', time: '50分钟'},
  {type: '7-8人制赛事', money: '320元/场', discount: '95折', time: '85分钟'},
  {type: '11人制赛事', money: '450元/场', discount: '95折', time: '135分钟'},
  {type: '球队单场友谊赛（2小时）', money: '400元/场', discount: '95折', time: '120分钟'},
  {type: '篮球/羽毛球/乒乓球其他活动', money: '咨询面议', discount: '', time: ''}
]
export default {
  data() {
    return {
      active: 0,
      serviceList: service
    }
  },
  created() {
    if (this.$route.query.active) {
      this.active = this.$route.query.active
    }
    this.share()
  },
  mounted() {
    if (AppType.isInApp()) {
      setTitle('视频拍摄服务')
    }
  },
  methods: {
    routerReservation(type) {
      this.$router.push({
        path: '/reservation',
        query: {
          type: type
        }
      })
    },
    share() {
      this.shareData = {
        title: '斑马赛事通，人人都能用得起的智能体育直播工具',
        link: window.location.href,
        image: ImageFormat.squareImageView('FoKGFlZjttio9HG_TfoBBXBnQLl3', 120),
        abstract: '设备简单无门槛，包装专业秒杀普通直播，智能记录、自动生成精彩集锦'
      }
      this.wxShare(this.shareData)
    },
    headTabs(name) {
      this.$router.replace({
        path: '/live-service',
        replace: true,
        query: {
          active: this.active
        }
      })
      this.$nextTick(() => {
        this.share()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  #live-service
    height 100%
    background-color white
    overflow scroll
    .shanghai, .other
      padding: 0 15px;
      h3
        font-size:16px;
        font-weight:500;
        color:rgba(102,102,102,1);
      .list
        font-size:12px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:17px;
        display flex
        align-items center
        margin-bottom: 10px
        span
          width:6px;
          height:6px;
          background:rgba(196,196,196,1);
          margin-right: 10px;
          border-radius 50px
        p
          margin: 0;
          font-size:12px;
          font-weight:400;
          color:rgba(51,51,51,1);
    .table-wrapper
      .header
        display flex
        border-bottom: 2px solid white;
        div
          flex 1
          text-align center
          padding: 5px 0;
          background-color #FF7472
          font-size:12px;
          font-weight:400;
          color:rgba(255,255,255,1);
        div:nth-child(2)
          border-left: 2px solid white;
          border-right: 2px solid white;
          box-sizing border-box;
        div:nth-child(3)
          border-right: 2px solid white;
          box-sizing border-box;
      .wrapper
        display flex
        div
          flex 1
          display flex
          justify-content center
          align-items center
          text-align center
          padding: 5px 0;
          background:rgba(241,241,241,1);
          font-size:12px;
          font-weight:400;
          color:rgba(102,102,102,1);
          border-bottom: 2px solid white;
        div:nth-child(2)
          border-left: 2px solid white;
          border-right: 2px solid white;
          box-sizing border-box;
        div:nth-child(3)
          border-right: 2px solid white;
          box-sizing border-box;
    .edit
      font-size:12px;
      font-weight:300;
      color:rgba(153,153,153,1);
    .info
      font-size:12px;
      font-weight:400;
      color:rgba(102,102,102,1);
      padding-bottom: 5px;
    .submit
      width 100 vw;
      height:55px;
      text-align center
      line-height 55px
      background:rgba(251,87,84,1);
      font-size:16px;
      font-weight:500;
      color:rgba(255,255,255,1);
      position fixed
      bottom: 0;
      left 0
    .submit-other
      display: flex
      position fixed
      bottom: 0;
      left 0
      width 100 vw;
      height:55px;
      div
        flex 1
        text-align center
        line-height 55px
        font-size:16px;
        font-weight:500;
        color:rgba(255,255,255,1);
      div:nth-child(1)
        background:rgba(251,87,84,1);
      div:nth-child(2)
        background: #124582;
    .online-advisory
      position: fixed;
      bottom:80px;
      right:8px;
      /*background: url("../images/client-chat.png") center no-repeat;*/
      /*background: url("/assets/images/human-services.png") center no-repeat;*/
      /*background-color:#cc3232;*/
      -webkit-background-size: cover;
      /*background-size: 70%;*/
      width:95px;
      height:46px;
      border-radius:37px;
      img
        width 100%
</style>



// WEBPACK FOOTER //
// src/pages/liveService/index.vue